import React from 'react'
import { withCookies } from 'react-cookie';
import Sidebar from './Sidebar.js'
import Filters from './Filters.js'
import ServicesContainer from './ServicesContainer.js'
import fetcher from '../servicesFetcher'
import omit from 'lodash.omit'

class Page extends React.Component {
  constructor(props) {
    super(props)
    let preferedLayout = props.cookies.get('prefered_directory_layout');
    this.state = {
      servicesToCompare: this.props.servicesToCompare.map(s => Object.assign(s, {visible: true})),
      filterKey: this.props.filters.map(f => f.filters.values[0]),
      allServiceTitles: this.props.allServiceTitles.sort((a,b) => a.brand.localeCompare(b.brand)),
      sideBarActive: true,
      layout: preferedLayout || 'table',
      preferedLayout,
      scrollPosition: 0,
      maxScrollPosition: 4,
      refreshKey: '',
      selectedSortValue: {label: 'A-Z', value: 'a-z'},
      accessLevel: 'bronze',
      filtersHidden: true,
      tableFieldCount: this.props.tableFieldCount > 0 ? this.props.tableFieldCount : 10,
      tileFieldCount: this.props.tileFieldCount > 0 ? this.props.tileFieldCount : 5,
      mobile: false
    }
  }

  hideFreeAccessCTA() {
    if(this.props.freeAccess == true && this.props.hasFreeAccessCta && this.state.layout == 'table') {
      if(this.state.scrollPosition <= -4) {
        document.querySelector('.cta-table-container').style.opacity = '0'
        document.querySelector('.cta-table-container').style.zIndex = '-1'
      } else {
        document.querySelector('.cta-table-container').style.opacity = '1'
        document.querySelector('.cta-table-container').style.zIndex = '2'
      }
    }
  }

  componentWillMount() {
    this.setAccessLevel()
    this.checkWidth()
  }

  componentDidUpdate() {
    this.hideFreeAccessCTA()
  }

  componentDidMount() {
    this.sortServices()
    this.hideFreeAccessCTA()
    window.addEventListener('resize', window.debounce(this.checkWidth.bind(this), 500))
  }

  checkWidth() {
    if (window.innerWidth < 960) {
      this.setState({
        layout: 'tile',
        mobile: true,
        sideBarActive: true
      })
    } else {
      this.setState({
        layout: this.state.preferedLayout || 'table',
        mobile: false
      })
    }
  }

  setAccessLevel() {
    const memberIsAtLeastSilver = this.props.silverMember == true
    let accessLevel

    if(memberIsAtLeastSilver)  {
      // show paid content
      accessLevel = 'silver'
    } else {
      if(this.props.freeAccess == true) {
        // show free access version
        // free acess
        accessLevel = 'freeAccess'
      } else {
        // hide content, show ctas
        accessLevel = 'bronze'
      }
    }
    this.setState({
      accessLevel: accessLevel
    })
  }

  updateServices(productId, remove = false, filtersHidden = true) {
    const that = this;
    let servicesToCompare = that.state.servicesToCompare;
    let service = servicesToCompare.find(s => s.id === productId);
    if (remove) {
      service.visible = false;
    } else {
      service.visible = true;
    }
    that.setState({
      servicesToCompare: servicesToCompare,
      filtersHidden: filtersHidden,
      refreshKey: Math.random()
    }, this.sortServices());
  }

  setFilterParamCookie() {
    const { values, selectedFilters, filters } = this.props;
    let cookie = '';
    this.state.filterKey.forEach((filter, index) => {
      if (filters.length > index) {
        if (index == 0) {
          url = url.concat(`${filters[index].filters.label}=${filter}`)
        } else {
          url = url.concat(`&${filters[index].filters.label}=${filter}`)
        }
      }
    });
    return url;
  }

  setFilterCookie() {
    const filterKey = this.state.filterKey;
    const filters = this.props.filters;
    let cookieString = '';
    filterKey.forEach((filter, index) => {
      if (filters.length > index) {
        if (index == 0) {
          cookieString = cookieString.concat(`${filters[index].filters.label}=${filter}`)
        } else {
          cookieString = cookieString.concat(`&${filters[index].filters.label}=${filter}`)
        }
      }
    });
    this.props.cookies.set('filter_params', cookieString, { path: '/' });
  }

  filterServices(e) {
    const filterKey = this.state.filterKey;
    filterKey[e.index] = e.value
    this.setState({
        filterKey: filterKey
      },
      this.sortServices(),
      this.setFilterCookie()
    )
  }

  clearAllServices() {
    const servicesToCompare = this.state.servicesToCompare.map(s => Object.assign(s, {visible: false}))
    this.setState({
      servicesToCompare: servicesToCompare
    })
  }

  toggleSidebar() {
    if(this.state.mobile) return
    this.setState({
      sideBarActive: !this.state.sideBarActive,
      scrollPosition: 0,
      maxScrollPosition: this.sideBarActive ? 4 : 6
    })
  }

  toggleLayout(view) {
    this.setState({
      layout: view,
      preferedLayout: view
    }, this.sortServices())
    this.props.cookies.set('prefered_directory_layout', view, { path: '/' });
  }

  updateScrollPosition(amount) {
    this.setState({
      scrollPosition: this.state.scrollPosition + amount
    })
  }

  updateSortValue(e) {
    this.setState({
      selectedSortValue: e
    }, this.sortServices(e))
  }

  sortServices(e) {
    // TODO this method as a callback after setState in updateSortValue won't pick up
    // the updated state of selectedSortValue
    let sortValue
    if(typeof e !== 'undefined') {
      sortValue = e.value
    } else {
      sortValue = this.state.selectedSortValue.value
    }
    let services = this.state.servicesToCompare,
        sortedServices

    if(sortValue === 'a-z') {
      sortedServices = this.sortAlphabetically(services)
    } else {
      sortedServices = this.sortByPrice(services, sortValue)
    }

    this.setState({
      servicesToCompare: sortedServices
    })
  }

  sortAlphabetically(services) {
    services.sort((a, b) => {
      return a.brand.localeCompare(b.brand)
    })
    return services
  }

  sortByPrice(services, sortValue) {
    services.sort((a, b) => {
      const filterKey = this.state.filterKey.join('')
      const aHasPriceValue = a.calculations.find(c => typeof c[filterKey] !== 'undefined')
      const bHasPriceValue = b.calculations.find(c => typeof c[filterKey] !== 'undefined')
      if(typeof aHasPriceValue === 'undefined' || typeof bHasPriceValue === 'undefined') {
        return false
      } else {
        const aValue = aHasPriceValue[filterKey]
        const bValue = bHasPriceValue[filterKey]
        if(sortValue == 'lowest-price') {
          return parseFloat(aValue) - parseFloat(bValue)
        } else {
          return parseFloat(bValue) - parseFloat(aValue)
        }
      }
    })

    return services
  }

  render() {
    // throw new Error('Page broken for testing');
    const newProps = omit(this.props, ['servicesToCompare', 'lowestMonthlyPrice'])
    return (
      <div className={`flex flex-column h-100 ${this.state.sideBarActive ? '' : 'sidebar-inactive'}`}>
        <Filters handleChange={this.filterServices.bind(this)}
                 updateSortValue={this.updateSortValue.bind(this)}
                 toggleLayout={this.toggleLayout.bind(this)}
                 layout={this.state.layout}
                 selectedSortValue={this.state.selectedSortValue}
                 filters={this.props.filters}
                 accessLevel={this.state.accessLevel}
                 sideBarActive={this.state.sideBarActive}
                 toggleSidebar={this.toggleSidebar.bind(this)}
                 filterParams={this.props.cookies.get('filter_params')}
                 mobile={this.state.mobile}
                 {...newProps} />
        {/* no h-100 - does not work on old iOS safaris */}
        <div className="flex content-container">
          <Sidebar allServiceTitles={this.state.allServiceTitles}
                 servicesToCompare={this.state.servicesToCompare.filter(s => s.visible).map(s => s.id)}
                 updateServices={this.updateServices.bind(this)}
                 clearAllServices={this.clearAllServices.bind(this)}
                 toggleSidebar={this.toggleSidebar.bind(this)}
                 key={this.state.refreshKey}
                 mobile={this.state.mobile}
                 accessLevel={this.state.accessLevel}
                 filtersHidden={this.state.filtersHidden}
                 {...newProps} />
          <ServicesContainer servicesToCompare={this.state.servicesToCompare.filter(s => s.visible)}
                           layout={this.state.layout}
                           filterKey={this.state.filterKey.join('')}
                           selectedFilters={this.state.filterKey}
                           scrollPosition={this.state.scrollPosition}
                           maxScrollPosition={this.state.maxScrollPosition}
                           updateScrollPosition={this.updateScrollPosition.bind(this)}
                           updateServices={this.updateServices.bind(this)}
                           fields={this.props.serviceFields}
                           tableFieldCount={this.state.tableFieldCount}
                           tileFieldCount={this.state.tileFieldCount}
                           accessLevel={this.state.accessLevel}
                           lowestMonthlyPrice={this.props.lowestMonthlyPrice}
                           {...newProps} />
        </div>
      </div>
      )
  }
}

export default withCookies(Page)
